import LiquidRender, { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import { parseTableByColumns } from '@gate31/core/src/libs/utils';
import { ModalDesk } from '../ModalDesk/ModalDesk';

interface templateDataIng {
    local: {
        title?: string;
        content?: string;
    };
    global: {
        title?: string;
        content?: string;
    };
}

export class TableSizeDesk {
    template: keyof LiquidTemplates;
    trigger: HTMLDivElement;
    templateData: templateDataIng;
    modal: ModalDesk;
    sizeTable: HTMLDivElement;
    measurementTable: HTMLDivElement;
    buttonsContainer: HTMLDivElement;
    abortController: AbortController;

    constructor({ template, trigger, templateData }: { template: keyof LiquidTemplates; trigger: HTMLDivElement; templateData: templateDataIng }) {
        this.template = template;
        this.trigger = trigger;
        this.templateData = templateData;

        this.connectionCallback();
        this.abortController = new AbortController();
    }

    connectionCallback() {
        this.createModal();

        this.trigger.addEventListener('click', () => {
            this.open();
        });
    }

    getModalContent(): string {
        return LiquidRender.render(this.template, this.templateData);
    }

    createModal() {
        const content = this.getModalContent();

        this.modal = new ModalDesk({
            template: 'modal-desk-template',
            content,
            disableBodyScroll: true,
            viewOpts: {
                closeIconSize: 'm'
            }
        });
    }

    toggleWrappers() {
        document.querySelectorAll('.TableSizeDesk__wrapper').forEach(el => el.classList.toggle('hidden'));
    }

    handleButtonClick(clicked: HTMLDivElement, activeClass: string) {
        if (clicked.classList.contains(activeClass)) {
            return;
        }
        if (clicked.getAttribute('data-table') === 'how') {
            this.toggleWrappers();
            return;
        }

        const buttons = this.buttonsContainer.children;

        // @ts-ignore
        for (const button of buttons) {
            if (button.getAttribute('data-table') === 'how') {
                continue;
            }
            button.classList.toggle(activeClass);
        }
        this.measurementTable?.classList.toggle('hidden');
        this.sizeTable?.classList.toggle('hidden');
    }

    handleClick(e: MouseEvent) {
        const target = e.target as HTMLDivElement;
        const buttonData = target.getAttribute('data-table');
        const activeClass = 'TableSizeDesk__table-name_active';

        if (buttonData) {
            this.handleButtonClick(target, activeClass);
        }
    }

    tableToDiv(tableWrapper: HTMLDivElement) {
        const tableEl = tableWrapper.querySelector<HTMLTableElement>('table');

        if (! tableEl) return;

        const tableData = parseTableByColumns(tableEl);
        const table = document.createElement('div');

        table.classList.add('div-table');

        tableData.forEach((rowData, i) => {
            const col = document.createElement('div');

            col.classList.add('div-table__col');
            if (i === 0) col.classList.add('div-table__row_header');

            rowData.forEach((cellData, j) => {
                const cell = document.createElement('div');

                cell.classList.add('div-table__cell');
                if (j === 0) cell.classList.add('div-table__col_header');

                cell.textContent = cellData;
                col.appendChild(cell);
            });

            table.appendChild(col);
        });
        return table;
    }

    renderNewTables() {
        document.querySelectorAll('.div-table').forEach(item => item.remove());
        if (this.measurementTable) {
            const divTable = this.tableToDiv(this.measurementTable);

            this.measurementTable.childNodes.forEach(item => item instanceof HTMLElement && item.classList.add('hidden'));
            if (divTable) this.measurementTable.appendChild(divTable);
        }

        if (this.sizeTable) {
            const divTableGlobal = this.tableToDiv(this.sizeTable);

            this.sizeTable.childNodes.forEach(item => item instanceof HTMLElement && item.classList.add('hidden'));
            if (divTableGlobal) this.sizeTable.appendChild(divTableGlobal);
        }
    }

    open() {
        this.abortController.abort();
        this.abortController = new AbortController();

        this.modal.open();
        const signal = this.abortController.signal;

        const buttonsContainer = document.querySelector<HTMLDivElement>('.TableSizeDesk__name-wrapper');
        const sizeTable = document.querySelector<HTMLDivElement>('.TableSizeDesk__table_global');
        const measurementTable = document.querySelector<HTMLDivElement>('.TableSizeDesk__table_local');
        const buttonBack = document.querySelector<HTMLDivElement>('.TableSizeDesk__table-back');

        if (sizeTable) this.sizeTable = sizeTable;
        if (measurementTable) this.measurementTable = measurementTable;
        if (buttonsContainer) this.buttonsContainer = buttonsContainer;

        this.renderNewTables();
        if (! this.sizeTable) {
            buttonsContainer?.querySelectorAll<HTMLDivElement>('div')
                .forEach(button => button.getAttribute('data-table') !== 'measurements' && button.classList.add('hidden'));
            const wrapper = document.querySelector<HTMLDivElement>('.TableSizeDesk');

            if (wrapper) {
                ! wrapper.classList.contains('TableSizeDesk_mini') && wrapper.classList.add('TableSizeDesk_mini');
            }
        }

        buttonBack?.addEventListener('click', () => this.toggleWrappers(), { signal });
        buttonsContainer?.addEventListener('click', e => this.handleClick(e), { signal });
    }
}
